import moment from "moment";
import { CalendarDate } from "./calendar-date";
export class Reminder {
    constructor() {
        this.id = null;
        this.parentName = "";
        this.parentHref = "";
        this.dueDate = null;
        this.dueDateTime = null;
        this.title = "";
    }
    when() {
        if (this.dueDate) {
            return this.dueDate.dayEnd();
        }
        else if (this.dueDateTime) {
            return this.dueDateTime;
        }
        return null;
    }
    clone() {
        return Reminder.clone(this);
    }
    static clone(source) {
        const theClone = new Reminder();
        theClone.id = source.id;
        theClone.parentName = source.parentName;
        theClone.parentHref = source.parentHref;
        theClone.dueDate = source.dueDate;
        theClone.dueDateTime = source.dueDateTime;
        theClone.title = source.title;
        return theClone;
    }
    static load(source) {
        const theClone = new Reminder();
        theClone.id = source.id;
        theClone.dueDate = source.dueDate
            ? CalendarDate.parse(source.dueDate).getOrElse(null)
            : null;
        theClone.dueDateTime = source.dueDateTime ? new Date(source.dueDateTime) : null;
        theClone.parentName = source.parentName;
        theClone.parentHref = source.parentHref;
        theClone.title = source.title;
        return theClone;
    }
}
export const isReminderPending = (reminder, now) => {
    const when = reminder.when();
    if (!when) {
        return false;
    }
    return !moment(when).isAfter(now, "day");
};
export const isReminderOverdue = (reminder, now) => {
    const when = reminder.when();
    if (!when) {
        return false;
    }
    return moment(when).isBefore(now, "day");
};
export const shouldAutoOpenReminders = (reminders, now) => reminders.some(reminder => isReminderPending(reminder, now));
export const hasOverdueReminders = (reminders, now) => reminders.some(reminder => isReminderOverdue(reminder, now));
//# sourceMappingURL=reminder.js.map